// Vendor imports
const Immutable = require('immutable')
const PropTypes = require('prop-types')
// Client V2 common imports
const { keyedReviver } = require('client-v2/common/state/revivers')

class ToastsNoticeRecord extends Immutable.Record({
  appearance: null,
  dismissed: Boolean(),
  id: Number(),
  message: null
}) {
  // No methods
}

ToastsNoticeRecord.reviver = keyedReviver(ToastsNoticeRecord, {
  // No nested data structures
})

ToastsNoticeRecord.propTypes = {
  appearance: PropTypes.string,
  dismissed: PropTypes.bool,
  id: PropTypes.number,
  message: PropTypes.oneOfType([
    PropTypes.func,
    PropTypes.string
  ])
}

module.exports = ToastsNoticeRecord
